<script lang="ts">
  import { onMount } from "svelte"
  import Layout from "$app/Layouts/Plan.svelte"
  import { Pulse } from "svelte-loading-spinners"
  import { xhr, toast } from "$app/utils"
  import AlignmentTests from "./AlignmentTests.svelte"
  import Participants from "./Participants.svelte"
  import { ClipboardList, Users } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"
  import { Target } from "lucide-svelte"

  let props = $props()
  let alignment_tests: AlignmentTestType[] = $state(props.alignment_tests || [])
  let alignment_only_members: UserType[] = $state(
    props.alignment_only_members || []
  )

  type tabType = { title: string; active: boolean }
  let tabs = $state([
    {
      title: "Alignment Tests",
      active: true
    },
    { title: "Participants", active: false }
  ])

  let activeTabTitle = $state(tabs.find((v) => v.active)?.title)

  function updateTab(tab: tabType): void {
    const activeTab = tabs.find((t) => t.active === true)
    activeTab.active = false
    tab.active = true
    tabs = tabs
  }

  let isLoading = $state(true)
  async function initialize(): Promise<void> {
    isLoading = true
    try {
      const resp = await xhr.get(
        `/plans/${appStore.plan.id}/alignment_tests.json`
      )

      let data = resp.data

      alignment_tests = data.alignment_tests
      alignment_only_members = data.alignment_only_members
    } catch (e) {
      console.log(e)
      toast("There was an error loading the alignment test data", "error")
    } finally {
      isLoading = false
    }
  }

  function updateAlignmentTests(data) {
    alignment_tests = data
  }

  function updateMembers(data) {
    alignment_only_members = data
    alignment_only_members = alignment_only_members
  }

  onMount(async () => {
    initialize()
  })
</script>

<Layout {...props}>
  <div class="max-w-5xl mx-auto pb-6">
    <div class="flex items-center justify-center py-6">
      <Target class="w-6 h-6 mr-2 text-gray-500" />
      <h1 class="text-2xl lg:text-3xl text-gray-600 font-bold">
        Alignment Tests
      </h1>
    </div>

    {#if isLoading}
      <div class="py-12 flex justify-center w-full">
        <Pulse size="240" color="#cdcdcd" unit="px" duration="1s" />
      </div>
    {:else}
      <div class="overflow-hidden">
        <div class="sm:hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <select
            id="tabs"
            name="tabs"
            class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
            bind:value={activeTabTitle}
            onchange={() => {
              updateTab(tabs.find((t) => t.title === activeTabTitle))
            }}
          >
            {#each tabs as tab (tab.title)}
              <option>{tab.title}</option>
            {/each}
          </select>
        </div>
        <div class="bg-white hidden sm:block">
          <div class="border-b border-gray-200">
            <nav class="tabs -mb-px flex justify-around" aria-label="Tabs">
              {#each tabs as tab (tab.title)}
                <button
                  class="tab flex items-center justify-center"
                  class:active={tab.active}
                  onclick={() => updateTab(tab)}
                >
                  {#if tab.title == "Alignment Tests"}
                    <ClipboardList class="w-6 h-6 mr-2" />
                  {:else if tab.title == "Participants"}
                    <Users class="w-6 h-6 mr-2" />
                  {/if}
                  {tab.title}
                </button>
              {/each}
            </nav>
          </div>
        </div>

        <div
          class="bg-white px-2 py-5 mt-6 md:mt-0"
          class:hidden={!tabs[0].active}
        >
          {#key alignment_only_members}
            <AlignmentTests
              {alignment_tests}
              {alignment_only_members}
              onupdate={updateAlignmentTests}
            />
          {/key}
        </div>

        <div
          class="bg-white px-4 py-5 sm:p-6 mt-6 md:mt-0"
          class:hidden={!tabs[1].active}
        >
          <Participants
            {alignment_only_members}
            onupdateMembers={updateMembers}
          />
        </div>
      </div>
    {/if}
  </div>
</Layout>
